<mat-card class="only-admin-wrapper">
  <mat-icon class="large-icon">block</mat-icon>
  <h1 class="only-admin-title">Restricted Access</h1>
  <p class="only-admin-description">
    The route you are trying to access is allowed only for admin users.
  </p>
</mat-card>
